<template>
  <section class="d-grid gap-3">
    <header class="d-flex justify-content-between align-items-start flex-wrap gap-3">
      <div>
        <h2 class="h5 mb-1">Cuentas por cobrar</h2>
        <p class="text-muted small mb-0">Deuda de clientes crédito con antigüedad (aging).</p>
      </div>
      <button class="btn btn-outline-dark btn-sm" :disabled="loading || !filas.length" @click="exportar">
        <i class="bi bi-download me-1"></i>Exportar CSV
      </button>
    </header>

    <div class="card shadow-sm">
      <div class="card-body">
        <div class="row g-2 align-items-end">
          <div class="col-auto">
            <label class="form-label small mb-1">Fecha de corte</label>
            <input v-model="filtros.fecha_corte" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-auto">
            <button class="btn btn-dark btn-sm" :disabled="loading" @click="cargar">
              {{ loading ? 'Buscando...' : 'Buscar' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="error" class="alert alert-danger mb-0">{{ error }}</div>

    <div v-if="totales" class="row g-3">
      <div class="col-md-4">
        <div class="card shadow-sm"><div class="card-body">
          <div class="text-muted small">Clientes con saldo</div>
          <div class="h5 mb-0">{{ totales.cantidad_clientes }}</div>
        </div></div>
      </div>
      <div class="col-md-4">
        <div class="card shadow-sm"><div class="card-body">
          <div class="text-muted small">Saldo total</div>
          <div class="h5 mb-0">{{ formatoMonto(totales.saldo_total) }}</div>
        </div></div>
      </div>
      <div class="col-md-4">
        <div class="card shadow-sm"><div class="card-body">
          <div class="text-muted small mb-1">Por antigüedad</div>
          <div v-for="(monto, bucket) in totales.por_bucket" :key="bucket" class="small">
            {{ etiquetaBucket(bucket) }}: {{ formatoMonto(monto) }}
          </div>
        </div></div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Cliente</th><th class="text-end">Saldo</th><th>Plazo (días)</th><th>Vencimiento</th><th>Antigüedad</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading"><td colspan="5" class="text-center py-4">Cargando...</td></tr>
            <tr v-else-if="!filas.length"><td colspan="5" class="text-center py-4 text-muted">Sin resultados</td></tr>
            <tr v-else v-for="f in filas" :key="f.cliente_id">
              <td>{{ f.cliente_nombre }}</td>
              <td class="text-end">{{ formatoMonto(f.saldo_actual) }}</td>
              <td>{{ f.plazo_dias_credito }}</td>
              <td>{{ f.fecha_vencimiento ? new Date(f.fecha_vencimiento).toLocaleDateString('es-PY') : 'Sin registrar' }}</td>
              <td>
                <span class="badge" :class="badgeClase(f.bucket_antiguedad)">{{ etiquetaBucket(f.bucket_antiguedad) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import reportsService from '@/services/reportsService'

const filtros = ref({ fecha_corte: new Date().toISOString().slice(0, 10) })
const filas = ref([])
const totales = ref(null)
const loading = ref(false)
const error = ref('')

const ETIQUETAS = {
  '0-30': '0-30 días',
  '31-60': '31-60 días',
  '61-90': '61-90 días',
  '90+': '90+ días',
  sin_vencimiento: 'Sin vencimiento',
}
function etiquetaBucket(bucket) {
  return ETIQUETAS[bucket] || bucket
}
function badgeClase(bucket) {
  if (bucket === '90+') return 'text-bg-danger'
  if (bucket === '61-90') return 'text-bg-warning'
  if (bucket === 'sin_vencimiento') return 'text-bg-secondary'
  return 'text-bg-light'
}
function formatoMonto(valor) {
  return new Intl.NumberFormat('es-PY', { maximumFractionDigits: 0 }).format(Number(valor) || 0)
}

async function cargar() {
  loading.value = true
  error.value = ''
  try {
    const data = await reportsService.getCuentasPorCobrar(filtros.value)
    filas.value = data.filas
    totales.value = data.totales
  } catch (e) {
    error.value = e?.response?.data?.message || 'No se pudo cargar el reporte.'
  } finally {
    loading.value = false
  }
}

async function exportar() {
  try {
    await reportsService.descargarCsv('cuentas-por-cobrar', filtros.value, 'cuentas-por-cobrar')
  } catch (e) {
    error.value = 'No se pudo exportar el CSV.'
  }
}

onMounted(cargar)
</script>
